import React from "react";
import { Button, Popconfirm, Space, Table, Tag } from "antd";
import { DeleteTwoTone, EditTwoTone } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import {
  deleteAlbumById,
  getAlbumList,
  selectAlbums,
  toggleAlbumById,
} from "../../store/slices/albumSlice";
import AddAlbumPopup from "./AddAlbumPopup";

const Album = () => {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSizeOptions: ["10", "20", "50"],
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const albumList = useSelector(selectAlbums);
  const dispatch = useDispatch();

  const fetchData = (pagination) => {
    setLoading(true);
    dispatch(
      getAlbumList(pagination.current, pagination.pageSize, (totalData) => {
        setPagination({ ...pagination, total: totalData });
        setLoading(false);
      })
    );
  };

  useEffect(() => {
    fetchData(pagination);
  }, []);

  const handleTableChange = (pagination) => {
    fetchData(pagination);
  };

  const handleDelete = (item) => {
    setConfirmLoading(true);
    dispatch(
      deleteAlbumById(item.id, () => {
        setConfirmLoading(false);
      })
    );
  };

  const changeStatus = (item) => {
    setConfirmLoading(true);
    dispatch(
      toggleAlbumById(item.id, () => {
        setConfirmLoading(false);
      })
    );
  };

  const columns = [
    {
      title: "Created Date",
      dataIndex: "dates",
      render: (_, record) => {
        return <p> {new Date(_.created_at).toLocaleDateString()}</p>;
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      render: (_, record) => {
        return <NavLink to={`/gallery/${record.id}`}>{_}</NavLink>;
      },
    },
    {
      title: "Description",
      dataIndex: "description",
    },

    {
      title: "Published on www",
      dataIndex: "isPublished",
      render: (_, record) => {
        return (
          <>
            <Space>
              {_ ? (
                <Tag color="green" style={{ width: 40 }}>
                  Yes
                </Tag>
              ) : (
                <Tag color="red" style={{ width: 40 }}>
                  No
                </Tag>
              )}
              <Popconfirm
                title={`Are you sure want to ${
                  _ ? "unpublish" : "publish"
                } this album?`}
                onConfirm={() => changeStatus(record)}
              >
                <Button style={{ width: "100px" }} type="default">
                  {_ ? "Unpublish" : "Publish"}
                </Button>
              </Popconfirm>
            </Space>
          </>
        );
      },
      width: "200px",
    },
    {
      title: "Actions",
      dataIndex: "isPublished",
      width: "100px",
      render: (_, record) => {
        return (
          <Space>
            <EditTwoTone
              title="Edit"
              twoToneColor="#1890ff"
              style={{
                fontSize: "20px",
                cursor: "pointer",
                marginRight: "8px",
              }}
              onClick={() => {
                setActiveItem(record);
                setIsModalVisible(true);
              }}
            />

            <Popconfirm
              confirmLoading={confirmLoading}
              title="Are you sure want to delete this album?"
              onConfirm={() => handleDelete(record)}
              placement="topRight"
            >
              <DeleteTwoTone
                title="Delete"
                twoToneColor="#ff0000"
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold" }}>Albums</h2>
      {isModalVisible && (
        <AddAlbumPopup closePopup={setIsModalVisible} item={activeItem} />
      )}
      <Space
        style={{
          width: "100%",
          marginBottom: "15px",
          justifyContent: "flex-end",
        }}
        size={10}
        direction="horizontal"
        align="end"
      >
        <Button
          type="primary"
          onClick={() => {
            setIsModalVisible(true);
            setActiveItem(null);
          }}
        >
          Add New Album
        </Button>
      </Space>
      <Table
        dataSource={albumList}
        columns={columns}
        loading={loading}
        bordered
        rowKey="id"
        pagination={pagination}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Album;
